import { ReactNode, useEffect, useRef, useState } from 'react';

import { Text, TextProps, Tooltip, TooltipProps } from '@mantine/core';

interface TruncatedTooltipProps extends Omit<TooltipProps, 'children'> {
    children: ReactNode;
    textProps?: TextProps;
    style?: React.CSSProperties;
}

export function TruncatedTooltip({ children, textProps, style, ...tooltipProps }: TruncatedTooltipProps) {
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const element = textRef.current;
        if (element) {
            setIsTruncated(element.scrollWidth > element.clientWidth);
        }
    }, [children]);

    return (
        <Tooltip disabled={!isTruncated} {...tooltipProps}>
            <Text
                ref={textRef}
                truncate="end"
                {...textProps}
                style={[textProps?.style, style]}
            >
                {children}
            </Text>
        </Tooltip>
    );
}
